import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", { class: "el-text__primary" }, " Search Results ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_DashboardLayout = _resolveComponent("DashboardLayout")!

  return (_openBlock(), _createBlock(_component_DashboardLayout, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createVNode(_component_Table, {
        id: "dataGrid",
        ref: "dataGrid",
        columns: _ctx.columns ? _ctx.columns : [],
        "grid-data": _ctx.grid.rows ? _ctx.grid.rows : []
      }, null, 8, ["columns", "grid-data"])
    ]),
    _: 1
  }))
}